// extracted by mini-css-extract-plugin
module.exports = {"headline":"Header_headline__OK44h"};